import { render, staticRenderFns } from "./service-locations-signature-card-edit.vue?vue&type=template&id=204b7807&scoped=true&"
import script from "./service-locations-signature-card-edit.vue?vue&type=script&lang=js&"
export * from "./service-locations-signature-card-edit.vue?vue&type=script&lang=js&"
import style0 from "./service-locations-signature-card-edit.vue?vue&type=style&index=0&id=204b7807&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204b7807",
  null
  
)

export default component.exports